import React, {useEffect, useState} from "react";
import {Button, Form, Input} from "antd";
import { useDispatch, useSelector } from "react-redux";
import {Link, useHistory} from "react-router-dom";
import IntlMessages from "util/IntlMessages";
import {userSignInVerify} from "../appRedux/actions";
import config from '../util/config'
import "./sForm.css";

import InfoView from "components/InfoView";
import {CisUI} from "../util/CISUI";
import axios from "../util/Api";
import Config from "../util/config";
import slocalStorage from "react-secure-storage";
import CircularProgress from "../components/CircularProgress";

const ForceToPasswordChange = (props) => {
    const history = useHistory();
    const [form] = Form.useForm();
    // const dispatch = useDispatch();
    // const history = useHistory();
    const [loader, setLoader] = useState(false);
    const authUser = useSelector(({ auth }) => auth.authUser);
    //
    // const [user,setUser] = useState({
    //     email : "",
    //     password : "",
    // });
    //
    // const onFinishFailed = (errorInfo) => {
    //     console.log("Failed:", errorInfo);
    // };
    //
    // // for(var i=0, len=localStorage.length; i<len; i++) {
    // //   var key = localStorage.key(i);
    // //   var value = localStorage[key];
    // //   console.log(key + " => " + value);
    // // }
    //
    // const onChange = (e) => {
    //     if(e.target.name === 'email') {
    //         setUser({
    //             email : e.target.value,
    //             password : user.password,
    //         })
    //     }
    //     else if(e.target.name === 'password') {
    //         setUser({
    //             email : user.email,
    //             password : e.target.value,
    //         })
    //     }
    //
    // }
    //

    useEffect(() => {
        console.log(authUser);
        if (authUser === null) {
            history.push("/");
        }
    }, [authUser]);
    const onFinish = (values) => {
        // console.log("finish",values)
        // values['email'] = user.email;
        // values['password'] = user.password;
        // dispatch(userPasswordChange(values));
        // form.setFields([
        //     {
        //         name: "password",
        //         errors: ["Hf", "ja", "sf"]
        //     }
        // ]);
        setLoader(true);
        axios.post(Config.apiserver+ 'forcepasswordreset', values)
            .then(res => {
                if(res.data.status === 1){
                    CisUI().showAlert("Success", "success", res.data.msg);
                    // localStorage.clear();
                    localStorage.removeItem("token");
                    slocalStorage.removeItem("token");
                    slocalStorage.removeItem("userInfo");
                    slocalStorage.removeItem("reconcile");
                    slocalStorage.removeItem("userData");
                    slocalStorage.removeItem("otpstatus");
                    slocalStorage.removeItem("titheID");
                    localStorage.removeItem("userData");
                    slocalStorage.removeItem("prm");

                    history.push("/login");
                    // window.location.reload();
                }
                else {
                    CisUI().showAlert("Success", "success", res.data.msg);
                    // localStorage.clear();
                    localStorage.removeItem("token");
                    slocalStorage.removeItem("token");
                    slocalStorage.removeItem("userInfo");
                    slocalStorage.removeItem("reconcile");
                    slocalStorage.removeItem("userData");
                    slocalStorage.removeItem("otpstatus");
                    slocalStorage.removeItem("titheID");
                    localStorage.removeItem("userData");
                    slocalStorage.removeItem("prm");

                    history.push("/login");
                    // window.location.reload();
                }
                setLoader(false)
            })
            .catch(err => {
                if(err.response.status === 422) {
                    // form.set
                    console.log("error", err.response.data.errors)
                    let errors = err.response.data.errors;
                    const fields = Object.entries(errors).map(([key, messages]) => ({
                        name: key,
                        errors: messages,
                    }));

                    form.setFields(fields);
                }
                setLoader(false);
            })
    };



    return (
        <>
            {/* <div id="particles-js"></div> */}
            {loader && <CircularProgress className={`form_custom_loader`}/>}

            <div className="s_form_area">

                <div className="s_form_left">
                    <img
                        alt="example"
                        src="/assets/images/penterpv1.png" className="s_login_logo"
                    />
                    <div className="s_left_text">

                    </div>

                    <div className="copy_right_area">{config.footerText}</div>
                </div>



                <div className="s_form_right">
                    {/* <div className="elememt2_img" style={{   backgroundImage: `url(${process.env.PUBLIC_URL + '/assets/images/bgg2.png'})`,  width: "346px",height: "330px",right: "52px",
        position: "absolute",top: "-160px", transform: "rotate(20deg)"}}></div> */}
                    <div className="row" style={{ width: "100%" }}>
                        <div className="col-md-6 offset-md-3">
                            <Form
                                // initialValues={{ remember: true }}
                                // name="basic"
                                onFinish={onFinish}
                                // onFinishFailed={onFinishFailed}
                                form={form}
                                layout="vertical"
                                name="input"
                                // ref={formRef}
                                // className="ant-advanced-search-form"
                                className="pfrom"
                            >

                                <h3 style={{color: 'white', marginBottom: '20px', fontSize: '20px'}}>Please Change Your Password</h3>
                                <div className="col-md-12 col-sm-6">
                                <Form.Item
                                    name="password"
                                    label="Password"
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please input your password!',
                                        },
                                    ]}
                                    hasFeedback
                                >
                                    <Input.Password />
                                </Form.Item>
                                </div>
                                <div className="col-md-12 col-sm-6">

                                <Form.Item
                                    name="password_confirmation"
                                    label="Confirm Password"
                                    dependencies={['password']}
                                    hasFeedback
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please confirm your password!',
                                        },
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (!value || getFieldValue('password') === value) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(new Error('The new password that you entered do not match!'));
                                            },
                                        }),
                                    ]}
                                >
                                    <Input.Password />
                                </Form.Item>
                                </div>

                                {/*<div className="mb-3">*/}
                                {/*    <Form.Item*/}
                                {/*        name="New Password"*/}
                                {/*        */}
                                {/*    >*/}
                                {/*        <Input.Password />*/}
                                {/*    </Form.Item>*/}
                                {/*    <label className="form-label" style={{color : 'white'}}>New Password</label>*/}
                                {/*    <input type="password" required name="password" className="form-control" />*/}
                                {/*</div>*/}
                                {/*<div className="mb-3">*/}
                                {/*    <label className="form-label" style={{color : 'white'}}>Confirm Password</label>*/}
                                {/*    <input type="password" required name="confirm_password" className="form-control" />*/}
                                {/*</div>*/}

                                {/*<div className="sub_link" style={{textAlign : 'right'}}>*/}
                                {/*    <Link to="/main/dashboard/crm">Skip For Now?</Link>*/}
                                {/*</div>*/}

                                <div className="mb-3">
                                    <ul style={{ marginLeft: '-11px', color: 'white', fontSize: '14px' }}>
                                        <li>Password must be at least 10 characters long.</li>
                                        <li>At least 1 uppercase Letter</li>
                                        <li>At least 1 lowercase Letter</li>
                                        <li>At least 1 number</li>
                                        <li>At least 1 special character</li>
                                    </ul>
                                </div>

                                <div className="mt-3">
                                    <Button htmlType="submit" className="primary" ><IntlMessages id="Change Password" /></Button>
                                    <Button htmlType="button" style={{ background: "#bd7b19c2", color: "#fff", border: "1px solid #bd7b19c2" }}
                                            className="secondary" onClick={() => history.push('/main/dashboard/crm')}><IntlMessages id="Skip For Now?" /></Button>
                                </div>
                                {/* <div className="elememt3_img" style={{   backgroundImage: `url(${process.env.PUBLIC_URL + '/assets/images/bgg1.png'})`,  width: "250px",height: "208px",right: "0px", position: "absolute",bottom: "0px", transform: "rotate(-20deg)"}}></div> */}
                            </Form>

                        </div>
                    </div>
                    <div className="copy_left_area">{config.footerText}</div>
                </div>
                <InfoView/>
            </div>
        </>
    );
};

export default ForceToPasswordChange;
